import { useState, useEffect, useRef } from 'react';
import { Menu } from 'antd';
import MenuListManager from 'components/LayoutPage/MenuListManager';
import MenuListStaff from 'components/LayoutPage/MenuListStaff';
import { checkExtraPermission, checkPermission, extractFirstSegment } from 'utils/function';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import {
  selectUser,
  selectPermissions,
  selectExtraPermissions,
  selectLineOrAdmin,
} from 'features/auth/authSlice';
import { useTranslation } from 'react-i18next';
import { useLocation, useHistory } from 'react-router-dom';

import {
  PERMISSION_DASHBOARD_ACCESS,
  PERMISSION_DEVICE_MANAGE,
  PERMISSION_LEAVE_OFF_ACCESS_PERSONAL,
  PERMISSION_TIMESHEET_REQUEST_APPROVAL,
  PERMISSION_WATCHINGLIST_MANAGE,
} from 'constants/permissions';
import { setCheckRow } from 'features/employee/employeeSlice';
import { IMenuList } from 'components/interfaces/MenuListSidebar';
import {
  selectConfiguration,
  setIdModuleSelection,
  setPathMenuScreen,
} from 'features/configuration/configurationSlice';
import {
  getAllMenuManage,
  getAllMenuScreenManage,
  getAllScreenManage,
} from 'features/configuration/configurationAction';
import { LIST_ICON } from 'features/configuration/pages/SetupMenuScreen/components/ListPath';
import { PermissionType } from 'hrm-common/extensions/enums/personel';
import { getUser, permisisonsLineManager } from 'utils/auth';

const Icon = (props: any) => (
  <span
    role="img"
    aria-label="fast-backward"
    className="anticon anticon-fast-backward ant-menu-item-icon"
  >
    <img alt="" src={props.src} />
  </span>
);

const SidebarMenu = () => {
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation(['menu']);
  const dataPermissions = useAppSelector(selectPermissions);
  const dataExtraPermissions = useAppSelector(selectExtraPermissions);
  const dataUser = useAppSelector(selectUser);
  const dispatch = useAppDispatch();

  const [visibleMenu, setVisibleMenu] = useState<IMenuList[]>([]);
  const [visibleMenuAPI, setVisibleMenuAPI] = useState(MenuListManager);
  const [loading, setLoading] = useState(true);
  const initialized = useRef(false);

  const [activeRoute, setActiveRoute] = useState(location.pathname);
  const [listPathname, setListPathname] = useState<string[]>([]);
  const pathnameFirst = location.pathname?.split('/')[1];
  const pathnameTwo = location.pathname?.split('/')[2];

  const dataStore = useAppSelector(selectConfiguration);
  const dataMenuScreenManage = dataStore?.dataMenuScreenManage?.result;
  const dataMenuManage = dataStore?.dataMenuManage?.result;
  const dataScreenManage = dataStore?.dataScreenManage?.result;
  const nameMenuScreen = dataStore?.nameMenuScreen;
  const idModuleSelection = dataStore?.idModuleSelection;
  const [openKeys, setOpenKeys] = useState<string[]>([nameMenuScreen]);
  const isAdmin = useAppSelector(selectLineOrAdmin);
  // Gọi API một lần duy nhất khi component mount
  useEffect(() => {
    const fetchData = async () => {
      if (!initialized.current && getUser()?.id) {
        initialized.current = true;
        setLoading(true);
        try {
          // Gọi các API song song để tối ưu thời gian
          await Promise.all([
            dispatch(getAllScreenManage({})),
            dispatch(getAllMenuManage({})),
            dispatch(getAllMenuScreenManage({})),
          ]);
        } finally {
          setLoading(false);
        }
      }
    };
    fetchData();
  }, [dispatch]);

  // Xử lý dữ liệu menu một lần khi có đủ dữ liệu
  useEffect(() => {
    if (!dataMenuScreenManage || !dataMenuManage || !dataScreenManage || loading) return;

    const processMenuData = () => {
      const dataProcess = dataMenuScreenManage?.map((item: any) => {
        // const dataMenuManageID = dataMenuManage?.find(
        //   (itemIcon: any) => itemIcon?.menuId === item.menuParent?.menuId,
        // )?.menuModuleSelection;
        const nameIcon = LIST_ICON?.find(
          (itemIcon: any) => itemIcon?.id === item.menuParent?.iconId,
        )?.icon;
        return {
          menuParent: item.menuParent?.menuName,
          iconId: nameIcon,
          menuModuleSelection: item.menuParent?.menuModuleSelection,
          dataMenuScreen: item?.dtmenuScreen?.map((itemMS: any) => ({
            id: itemMS?.id,
            subMenu: itemMS?.manageMenu?.menuName || itemMS?.id,
            screen: itemMS?.manageScreen?.nameScreen,
            permissions: itemMS?.manageScreen?.permissions,
            path: itemMS?.manageScreen?.path,
            url: itemMS?.manageScreen?.url,
          })),
        };
      });

      const MenuListManager = dataProcess
        ?.map((item: any) => {
          if (!item?.dataMenuScreen?.length) return null;

          const arrPath = item?.dataMenuScreen
            ?.map((menuItem: any) => menuItem.path)
            .filter(Boolean)
            .flat(Infinity);

          const checkExtra =
            arrPath.includes('/manage/request_approval') ||
            arrPath.includes('/manage-overtime/overtime-plan-request') ||
            arrPath.includes('/manage-overtime/history-overtime-plan-request');

          if (item.dataMenuScreen.length > 1) {
            return {
              title: item.menuParent,
              path: ``,
              permissions: item?.dataMenuScreen
                ?.map((itemData: any) => itemData?.permissions)
                .flat(Infinity),
              extraPermissions: checkExtra ? ['PROJECT_LEADER'] : [],
              icon: <Icon src={item.iconId} />,
              menuModuleSelection: item.menuModuleSelection,
              menu: Array.from(new Set(item?.dataMenuScreen.map((s) => s.subMenu)))
                .map((lab) => {
                  const menuItems = item?.dataMenuScreen.filter((s: any) => s.subMenu === lab);
                  const path = menuItems[0]?.path;

                  if (!path) return null;

                  if (menuItems.length <= 1) {
                    return {
                      title: menuItems[0]?.screen,
                      path: path,
                      permissions: menuItems[0]?.permissions,
                      extraPermissions:
                        path === '/manage/request_approval' ||
                        path === '/manage-overtime/overtime-plan-request' ||
                        path === '/manage-overtime/history-overtime-plan-request'
                          ? ['PROJECT_LEADER']
                          : [],
                    };
                  } else {
                    return {
                      title: lab,
                      path: '',
                      permissions: menuItems
                        ?.map((itemData: any) => itemData?.permissions)
                        .flat(Infinity),
                      menu: menuItems
                        ?.map((itemData: any) => {
                          const path = itemData?.path;
                          return {
                            title: itemData.screen,
                            path: path,
                            permissions: itemData?.permissions,
                            extraPermissions:
                              path === '/manage/request_approval' ||
                              path === '/manage-overtime/overtime-plan-request' ||
                              path === '/manage-overtime/history-overtime-plan-request'
                                ? ['PROJECT_LEADER']
                                : [],
                          };
                        })
                        .filter(Boolean),
                    };
                  }
                })
                .filter(Boolean),
            };
          } else {
            return {
              title: item.menuParent,
              icon: <Icon src={item.iconId} />,
              path: item?.dataMenuScreen[0]?.path,
              menuModuleSelection: item.menuModuleSelection,
              permissions: item?.dataMenuScreen
                ?.map((itemData: any) => itemData?.permissions)
                .flat(Infinity),
              extraPermissions:
                item?.dataMenuScreen[0]?.path === '/manage/request_approval' ||
                item?.dataMenuScreen[0]?.path === '/manage-overtime/overtime-plan-request' ||
                item?.dataMenuScreen[0]?.path === '/manage-overtime/history-overtime-plan-request'
                  ? ['PROJECT_LEADER']
                  : [],
              url: item?.dataMenuScreen[0]?.url,
            };
          }
        })
        .filter(Boolean);

 
      const MenuByAdminRoleOrLine = isAdmin
        ? MenuListManager
        : MenuListManager?.filter((item) =>
            permisisonsLineManager.some((i) => item?.permissions?.includes(i)),
          );
      setVisibleMenuAPI(MenuByAdminRoleOrLine);
      // setVisibleMenuAPI(MenuListManager);
    };

    processMenuData();
  }, [dataMenuScreenManage, dataMenuManage, dataScreenManage, loading, isAdmin]);

  function joinSubPathAndFlatten(list: IMenuList[]): string[] {
    const result = collectMenu(list);
    const fatten = result.flatMap((e) => e);
    return fatten?.map((e) => {
      if (!Array.isArray(e)) {
        return e;
      }
      return e.join('');
    });
  }

  function collectMenu(list: IMenuList[]) {
    if (!list || !Array.isArray(list)) {
      throw Error('Required Array Date');
    }
    return list?.map((item) => flattenArrayString(item));
  }

  function flattenArrayString(item: IMenuList): string[] {
    const { path, menu } = item;

    if (!menu || !Array.isArray(menu)) {
      return [path];
    }
    return menu
      ?.map((e: IMenuList) => flattenArrayString(e)?.map((e: string) => path + e))
      ?.reduce((preValue: string[], curValue: string[]) => {
        return preValue?.concat(curValue);
      }, []);
  }

  const checkActiveRoute = () => {
    const pathNameMenu = listPathname.find((item) => location.pathname.startsWith(item));
    return setActiveRoute(pathNameMenu || '');
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => checkActiveRoute(), [listPathname, location.pathname]);
  useEffect(
    () => setListPathname(joinSubPathAndFlatten(visibleMenu ? visibleMenu : [])),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [visibleMenu],
  );
  useEffect(() => {
    let newOpenKeys = [];
    pathnameFirst && newOpenKeys.push(`/${pathnameFirst}`);
    pathnameTwo && newOpenKeys.push(`/${pathnameFirst}/${pathnameTwo}`);

    setOpenKeys([...openKeys, ...newOpenKeys]);
    dispatch(setCheckRow([]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  const checkIsStaff = () => {
    if (
      dataPermissions?.length === 10 &&
      dataPermissions?.includes(
        PermissionType.TIMESHEET_VIEW_OBSERVATION &&
          PermissionType.PROFILE_ACCESS_PERSONAL &&
          PermissionType.TIMESHEET_ACCESS_PERSONAL &&
          PermissionType.PAYSLIP_ACCESS_PERSONAL &&
          PermissionType.TIMEKEEPING_ACCESS_PERSONAL &&
          PermissionType.ONBOARD_ACCESS_PERSONNEL &&
          PermissionType.OFFBOARD_ACCESS_PERSONNEL &&
          PermissionType.DEVICE_ACCESS_PERSONNEL &&
          PermissionType.TIMESHEET_ACCESS_OBSERVATION_LIST &&
          PERMISSION_LEAVE_OFF_ACCESS_PERSONAL,
      )
    ) {
      return true;
    }

    return false;
  };

  useEffect(() => {
    var tempMenu = [...MenuListStaff];
    if (
      !checkIsStaff() ||
      dataPermissions?.includes(PERMISSION_DASHBOARD_ACCESS.DASHBOARD_ACCESS_HR) ||
      dataPermissions?.includes(PERMISSION_DASHBOARD_ACCESS.DASHBOARD_ACCESS_MANAGER) ||
      dataPermissions?.includes(PERMISSION_DEVICE_MANAGE.DEVICE_MANAGE) ||
      dataUser?.isSystemAdmin ||
      dataUser?.extraPermissions?.length
    ) {
      tempMenu = visibleMenuAPI?.map((item) => {
        const parentItem: IMenuList = { ...item };
        if (parentItem.menu) {
          let newSubMenu = parentItem.menu.filter((subMenu) => {
            return checkPermission(dataPermissions, subMenu.permissions, dataUser?.isSystemAdmin);
          });
          //Remove duplicate watching list base on role
          if (
            dataUser?.permissions?.includes(
              PERMISSION_WATCHINGLIST_MANAGE.WATCHINGLIST_MANAGER_REQUEST_LIST_VIEW,
            ) &&
            dataUser?.permissions?.includes(
              PERMISSION_WATCHINGLIST_MANAGE.WATCHINGLIST_HR_REQUEST_LIST_VIEW,
            )
          ) {
            newSubMenu = newSubMenu?.filter(
              (subMenu: any) =>
                !subMenu.permissions.includes(
                  PERMISSION_WATCHINGLIST_MANAGE.WATCHINGLIST_MANAGER_REQUEST_LIST_VIEW,
                ),
            );
          }
          let newExtraSubMenu =
            parentItem.menu &&
            parentItem.menu.filter((subMenu) => {
              return checkExtraPermission(
                dataExtraPermissions,
                subMenu.extraPermissions,
                dataUser?.isSystemAdmin,
              );
            });
          //Remove duplicate OT Plan base on role
          if (
            dataUser?.permissions?.includes(
              PERMISSION_TIMESHEET_REQUEST_APPROVAL.TIMESHEET_REQUEST_APPROVAL,
            )
          ) {
            newSubMenu = newSubMenu?.filter(
              (subMenu: any) => !subMenu.path.includes('overtime-plan-request'),
            );
          }

          //Remove duplicate OT Plan base on role
          if (
            dataUser?.permissions?.includes(
              PERMISSION_TIMESHEET_REQUEST_APPROVAL.TIMESHEET_REQUEST_APPROVAL,
            )
          ) {
            newExtraSubMenu = newExtraSubMenu?.filter(
              (subMenu: any) => !subMenu.path.includes('overtime-plan-request'),
            );
          }
          parentItem.menu = [...newSubMenu, ...newExtraSubMenu].filter(
            (v, i, a) => a.findIndex((v2) => v2.title === v.title) === i,
          );
        }

        return parentItem;
      });
    }

    const dataVisible = tempMenu?.filter((item) => {
      return checkPermission(dataPermissions, item.permissions, dataUser?.isSystemAdmin);
    });
    const dataExtraVisible = tempMenu?.filter((item) => {
      return checkExtraPermission(
        dataExtraPermissions,
        item.extraPermissions,
        dataUser?.isSystemAdmin,
      );
    });
    const newArray = [...(dataVisible || []), ...(dataExtraVisible || [])];
    const newArrayMemuV1 = newArray.filter(
      (v, i, a) =>
        a.findIndex((v2) => {
          if (Array.isArray(v2.menu)) {
            const viewPath = v2.menu.filter((itemMenu) => {
              return itemMenu.path === location.pathname;
            });
            if (viewPath.length > 0) {
              setOpenKeys([v2.title]);
              dispatch(setIdModuleSelection(v2?.menuModuleSelection?.id));
            }
          }
          return v2.title === v.title;
        }) === i,
    );
    const newArrayMemuV2 = newArrayMemuV1.filter(
      (item: any) =>
        item?.menuModuleSelection && item?.menuModuleSelection?.id === idModuleSelection,
    );
    const isPermissionsUser = getUser()?.permissions?.includes(PERMISSION_DASHBOARD_ACCESS.DASHBOARD_ACCESS_HR)
    setVisibleMenu(isPermissionsUser ? newArrayMemuV2 : newArrayMemuV1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visibleMenuAPI, location.pathname, idModuleSelection]);

  const onOpenChange = (keys: any) => {
    // keys.pop();
    setOpenKeys(keys);
  };

  const handleMenuClick = (e: any) => {
    const submenu = document.querySelector(`[data-menu-id="${e?.key}"]`);
    if (!document?.querySelector(`.ant-menu-submenu-open[data-menu-id="${e?.key}"]`)) {
      submenu?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <Menu
      mode="inline"
      theme="dark"
      selectedKeys={[activeRoute]}
      openKeys={openKeys}
      // onClick={({ item, key }: any) => {
      onClick={({ key }: any) => {
        if (!key) return;

        let arrPath = key.split('/');
        arrPath.pop();
        dispatch(setPathMenuScreen(key));
        setActiveRoute(key);
        history.push(key);
      }}
      onOpenChange={onOpenChange}
    >
      {visibleMenu?.map((item: any, index: any) => {
        if (Array.isArray(item.menu)) {
          return (
            <Menu.SubMenu
              key={item.title}
              title={t(`menu:${item.title}`)}
              icon={item.icon}
              data-menu-id={`${item.title}`}
              onTitleClick={handleMenuClick}
            >
              {item.menu.map((subItem: any, idx: any) => {
                if (Array.isArray(subItem.menu)) {
                  return (
                    <Menu.SubMenu
                      key={subItem.title + item.path + subItem.path}
                      title={t(`menu:${subItem.title}`)}
                      icon={subItem.icon}
                    >
                      {subItem.menu.map((subItemChild: any, i: any) => {
                        return (
                          <Menu.Item
                            key={
                              item.path + subItem.path + subItemChild.path
                              // +
                              // '/' +
                              // subItem.title +
                              // subItemChild.title
                            }
                            icon={subItemChild.icon}
                          >
                            {t(`menu:${subItemChild.title}`)}
                          </Menu.Item>
                        );
                      })}
                    </Menu.SubMenu>
                  );
                }
                return (
                  <Menu.Item
                    key={
                      item.path + subItem.path
                      // + '/' + subItem.title
                    }
                    icon={subItem.icon}
                  >
                    {t(`menu:${subItem.title}`)}
                  </Menu.Item>
                );
              })}
            </Menu.SubMenu>
          );
        }
        return (
          <Menu.Item key={item.path} icon={item.icon}>
            {t(`menu:${item.title}`)}
          </Menu.Item>
        );
      })}
    </Menu>
  );
};
export default SidebarMenu;
